import React, { Component } from "react";
import { Redirect } from "react-router";
import { connect } from "react-redux";
import { FaUserCircle } from "react-icons/fa";
import Popover from "../../components/uielements/popover";
import IntlMessages from "../../components/utility/intlMessages";
import authAction from "../../redux/auth/actions";
import { Divider } from "antd";
import appAction from "../../redux/app/actions";
import TopbarDropdownWrapper from "./topbarDropdown.style";
import { Link } from "react-router-dom";


const { logout, logoutPopup } = authAction;
const { closeAll } = appAction;

class TopbarUser extends Component {
  constructor(props) {
    super(props);
    this.handleVisibleChange = this.handleVisibleChange.bind(this);
    this.hide = this.hide.bind(this);
    this.state = {
      visible: false,
      redirectToProfile: false,
      confirmLogout: false,
    };
  }

  hide() {
    this.setState({ visible: false, confirmLogout: false });
  }

  handleVisibleChange(val) {
    this.setState({ visible: val, confirmLogout: false });
  }

  handleLogoutConfirm = () => {
    this.hide();
    this.props.logoutPopup();
    this.props.closeAll();
  };

  render() {
    if (this.state.redirectToProfile) {
      return <Redirect to={"/dashboard/Profile"} />;
    }

    const { confirmLogout } = this.state;

    const content = (
      <TopbarDropdownWrapper className="isoUserDropdown">
        {!confirmLogout ? (
          <>
            <div className="compnayuser-name">
              <small><IntlMessages id={"sidebar.Welcome"} />,</small>
              <br />
              {this.props.Auth && this.props.Auth.nameAlias && (
                <p className="Top-username Top-displayname">
                  {this.props.Auth.nameAlias}
                </p>
              )}
              <p className="Top-username">
                {this.props.Auth &&
                  this.props.Auth.profileData &&
                  this.props.Auth.profileData.emailId}
              </p>
            </div>
            <Divider style={{ marginBottom: "0px", marginTop: "2px" }} />
            <Link
              className="isoDropdownLink"
              onClick={(e) => {
                e.preventDefault();
                this.setState({ confirmLogout: true });
              }}
              to=""
            >
              <IntlMessages id="sidebar.Logout" />
            </Link>
          </>
        ) : (
          <div style={{
            padding: "20px 18px 16px",
            fontFamily: '"DM Sans", -apple-system, sans-serif',
          }}>
            <div style={{
              display: "flex", alignItems: "center", gap: 10, marginBottom: 10,
            }}>
              <div style={{
                width: 32, height: 32, borderRadius: "50%",
                background: "rgba(212,88,10,0.12)",
                display: "flex", alignItems: "center", justifyContent: "center",
                flexShrink: 0,
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="#E8572D" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
              </div>
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#0D1B2A" }}>Confirm Logout</div>
                <div style={{ fontSize: 12, color: "#8FA4BA", marginTop: 2 }}>Are you sure you want to log out?</div>
              </div>
            </div>

            <div style={{ display: "flex", gap: 8, marginTop: 14 }}>
              <button
                onClick={() => this.setState({ confirmLogout: false })}
                style={{
                  flex: 1, padding: "7px 0", borderRadius: 7,
                  border: "1px solid #C8D6E3", background: "#fff",
                  color: "#4A6480", fontSize: 12, fontWeight: 600,
                  cursor: "pointer", fontFamily: "inherit",
                }}
              >
                Cancel
              </button>
              <button
                onClick={this.handleLogoutConfirm}
                style={{
                  flex: 1, padding: "7px 0", borderRadius: 7,
                  border: "none",
                  background: "linear-gradient(135deg, #E8572D 0%, #F06A20 100%)",
                  color: "#fff", fontSize: 12, fontWeight: 600,
                  cursor: "pointer", fontFamily: "inherit",
                }}
              >
                Logout
              </button>
            </div>
          </div>
        )}
      </TopbarDropdownWrapper>
    );

    return (
      <Popover
        content={content}
        trigger="click"
        visible={this.state.visible}
        onVisibleChange={this.handleVisibleChange}
        arrowPointAtCenter={true}
        placement="bottomLeft"
      >
        <FaUserCircle className="logoutIconStyle" />
      </Popover>
    );
  }
}

export default connect(
  state => ({ Auth: state.Auth }),
  { logout, logoutPopup, closeAll }
)(TopbarUser);
